module.exports = __webpack_public_path__ + "img/9788927808114.c8cfb3fc.jpg";